// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Z_Hv","requiredAsterisk":"Info_requiredAsterisk__2wBWg"};